import { combineReducers } from 'redux'

import { i18nState } from "redux-i18n"

import accommodationsComparator from './accommodationsComparator'
import guestsSatisfactionComparator from './guestsSatisfactionComparator'
import touristSourceComparator from './touristSourceComparator'

import accommodationsData from './accommodationsData' 
import guestsSatisfactionData from './guestsSatisfactionData'
import touristSourceData from './touristSourceData'

import accommodationsState from './accommodationsState'
import guestsSatisfactionState from './guestsSatisfactionState'
import touristSourceState from './touristSourceState'

const reducers = combineReducers({
    i18nState,
    accommodationsComparator,
    guestsSatisfactionComparator,
    touristSourceComparator,
    accommodationsData,
    guestsSatisfactionData,
    touristSourceData,
    accommodationsState,
    guestsSatisfactionState,
    touristSourceState
})

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js